const LISTING_ENTITIES_SLICE = 'listingEntities';

export function applyEntityDocumentUpdate(state, action, documentId, updater) {
	if (!documentId || typeof updater !== 'function') {
		return state;
	}

	return applySliceDocumentUpdate(state, LISTING_ENTITIES_SLICE, documentId, updater);
}

function applySliceDocumentUpdate(state, targetSlice, documentId, updater) {
	if (!state?.[targetSlice]?.byId) {
		return state;
	}

	if (!getEntitySliceDocumentById(state, targetSlice, documentId)) {
		return state;
	}

	return updateEntitySliceDocuments(state, targetSlice, documentId, updater);
}

function getEntitySliceDocumentById(state, targetSlice, documentId) {
	const entities = Object.values(state?.[targetSlice]?.byId || {});

	for (let i = 0; i < entities.length; i++) {
		const entity = entities[i];
		if (!entity) {
			continue;
		}

		const document = findDocumentById(entity.relatedDocuments, documentId) || findDocumentById(entity.objectRelatedDocuments, documentId);
		if (document) {
			return document;
		}
	}

	return null;
}

function updateEntitySliceDocuments(state, targetSlice, documentId, updater) {
	let hasChanges = false;
	const updatedEntitiesById = {};

	Object.entries(state[targetSlice].byId).forEach(([entityId, entity]) => {
		const updatedEntity = updateEntityDocumentCollections(entity, documentId, updater);
		if (updatedEntity !== entity) {
			hasChanges = true;
		}
		updatedEntitiesById[entityId] = updatedEntity;
	});

	if (!hasChanges) {
		return state;
	}

	return {
		...state,
		[targetSlice]: {
			...state[targetSlice],
			byId: updatedEntitiesById
		}
	};
}

function updateEntityDocumentCollections(entity, documentId, updater) {
	if (!entity) {
		return entity;
	}

	const collectionKeys = ['relatedDocuments', 'objectRelatedDocuments'];
	let changed = false;
	const updatedEntity = {...entity};

	collectionKeys.forEach((key) => {
		const documents = updatedEntity[key];
		if (!Array.isArray(documents) || documents.length === 0) {
			return;
		}

		let collectionChanged = false;
		const updatedDocuments = documents.map((document) => {
			if (document?.id !== documentId) {
				return document;
			}

			collectionChanged = true;
			return updater(document);
		});

		if (collectionChanged) {
			changed = true;
			updatedEntity[key] = updatedDocuments;
		}
	});

	return changed ? updatedEntity : entity;
}

function findDocumentById(documents, documentId) {
	if (!Array.isArray(documents) || documents.length === 0) {
		return null;
	}

	for (let i = 0; i < documents.length; i++) {
		if (documents[i]?.id === documentId) {
			return documents[i];
		}
	}

	return null;
}
